import * as React from "react";
const SvgArrowDown2 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 7, viewBox: "0 0 10 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 0V3.16666L5 6.99999L0 3.16666V0L5 3.83334L10 0Z", fill: "#222222" }));
export default SvgArrowDown2;
